import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import DeepTissueMassage from "@/pages/services/DeepTissueMassage";
import ThaiMassage from "@/pages/services/ThaiMassage";
import FullBodyMassage from "@/pages/services/FullBodyMassage";
import AromatherapyMassage from "@/pages/services/AromatherapyMassage";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/services/deep-tissue-massage"
              element={<DeepTissueMassage />}
            />
            <Route path="/services/thai-massage" element={<ThaiMassage />} />
            <Route
              path="/services/full-body-massage"
              element={<FullBodyMassage />}
            />
            <Route
              path="/services/aromatherapy-massage"
              element={<AromatherapyMassage />}
            />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
